import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchProductsSitesAndUnitOfOperations } from "../redux/visualization/actions";

export default function AuthenticatedBaseFilters() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) dispatch(fetchProductsSitesAndUnitOfOperations());
  }, [dispatch, token, pathname]);

  return null;
}
